import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import * as Constants from '../../../helpers/constants'
import showToastNotification from '../../widgets/toastify'
import { ApiHelper } from '../../../helpers/apihelper'


const initialState = {
  emailAddress: '',
  errors: {},
}

const RemoveEmailFromCache = ({ client }) => {
  const [state, setState] = useState(initialState)
  const userId = useSelector((state) => state.user.id)

  const handleEmailChange = (e) => {
    const emailValue = e.target.value
    setState((prevState) => ({ ...prevState, emailAddress: emailValue }))
  }

  const validateEmail = (email) => {
    const emailRegex = Constants.REGEX.EMAIL_SYNTAX
    const isValidEmail = emailRegex.test(email)

    if (!isValidEmail) {
      setState((prevState) => ({
        ...prevState,
        errors: { emailAddress: 'Enter a valid email address' },
      }))

      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          errors: { emailAddress: null },
        }))
      }, 5000)
    }

    return isValidEmail
  }

  const handleRemoveEmail = () => {
    const isValid = validateEmail(state.emailAddress)
    if (!isValid) return

    const requestQueryParams = {
      email_address: state.emailAddress,
      user_id: userId,

    }

    const queryParams = _.pick(
      requestQueryParams,
      ApiHelper(client, 'REMOVE_EMAIL_FROM_CACHE').API_QUERY
    )

    ApiHelper(client, 'REMOVE_EMAIL_FROM_CACHE')
      .API(client, queryParams)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: 'Failed',
            isSuccess: false,
          })
        } else {
          showToastNotification({
            message: 'Removed Email from Cache',
            isSuccess: true,
          })

          setState(initialState)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <div className='mis-wrapper'>
      <h5 className='heading-title'>Manage Your Email Finder Settings</h5>
      <p className='heading-subtext'>
        Remove email from cache
      </p>
      <Form className='remove-email-from-cache__form'>
        <Form.Group className='mt-4'>
          <Form.Label
            htmlFor='remove-email-from-cache__input'
            className='mb-1'
          >
            Email Address:
          </Form.Label>
          <Form.Control
            type='email'
            id='remove-email-from-cache__input'
            placeholder='Enter email address'
            value={state.emailAddress}
            onChange={handleEmailChange}
            isInvalid={!!state.errors.emailAddress}
          />
          <Form.Control.Feedback type='invalid'>
            {state.errors.emailAddress}
          </Form.Control.Feedback>
        </Form.Group>
        <div className='remove-email-from-cache__button'>
          <Button
            variant='outline-danger'
            onClick={handleRemoveEmail}
            disabled={state.emailAddress.length === 0}
          >
            Remove
          </Button>
        </div>

      </Form>
    </div>
  )
}

export default RemoveEmailFromCache

